module.exports = __webpack_public_path__ + "startpage-746fed5a/template-5-2x-bc170faebb43de630703071cc640fa2a.jpg";